const delInitialState = {
  deleting: false,
};

const del = (state = delInitialState, action) => {
  switch (action.type) {
    case 'DELETE_FUNNEL':
      return {
        ...state,
        deleting: true,
      };

    case 'DELETE_FUNNEL_SUCCESS':
      return delInitialState;

    case 'DELETE_FUNNEL_FAILURE':
      return {
        ...state,
        deleting: false,
      };

    default:
      return state;
  }
};
export default del;

export const isDeleting = (state) => state.deleting;
